import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-coaching/articles")({
  staticData: { title: "My articles" },
  component: () => <Outlet />,
});
